import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
